import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'
import { isUUID } from '../utils/validations'

const ASSIGN_BY_STATUS = 'massAssign/ASSIGN_BY_STATUS'
const ASSIGN_BY_STATUS_SUCCESS = 'massAssign/ASSIGN_BY_STATUS_SUCCESS'
const ASSIGN_BY_STATUS_FAIL = 'massAssign/ASSIGN_BY_STATUS_FAIL'
const RESET_SYNC = 'massAssign/RESET_SYNC'

export const actions = {
  ASSIGN_BY_STATUS,
  ASSIGN_BY_STATUS_SUCCESS,
  ASSIGN_BY_STATUS_FAIL,
  RESET_SYNC
}

export const initialState = {
  sync: {
    active: false,
    date: null,
    fail: false,
    success: false,
    tasksCreated: null
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_BY_STATUS:
      const date = new Date()
      return {
        ...state,
        sync: {
          active: true,
          date: date.toLocaleDateString(),
          fail: false,
          success: false,
          tasksCreated: null
        }
      }
    case ASSIGN_BY_STATUS_SUCCESS:
      const { payload } = action
      const validResponse = payload !== undefined && payload.tasksCreated !== undefined
      return {
        ...state,
        sync: {
          ...state.sync,
          fail: !validResponse,
          success: validResponse,
          tasksCreated: validResponse ? payload.tasksCreated : null
        }
      }
    case ASSIGN_BY_STATUS_FAIL:
      return {
        ...state,
        sync: {
          ...state.sync,
          fail: true
        }
      }
    case RESET_SYNC:
      return {
        ...state,
        sync: initialState.sync
      }
    default:
      return state
  }
}

export default reducer

export function assignByStatus({ clientId, formId, selected, versionId }) {
  const data = {
    stageIds: selected.statuses.map((x) => parseInt(x, 10)),
    locationPositionIds: {
      locationIds: selected.locations.map((x) => parseInt(x, 10)),
      positionIds: selected.positions.map((x) => parseInt(x, 10))
    }
  }

  const apiVersion = isUUID(formId) ? 'v2' : 'v1'
  const v2text = isUUID(formId) && versionId ? 'version/' + versionId + '/' : ''

  return {
    type: CALL_API,
    types: [ASSIGN_BY_STATUS, ASSIGN_BY_STATUS_SUCCESS, ASSIGN_BY_STATUS_FAIL],
    callAPI: () =>
      axios.post(`/forms/${formId}/${v2text}assignByStatus`, data, {
        ...fetchOptions(apiVersion)
      })
  }
}

export function resetSync() {
  return {
    type: RESET_SYNC
  }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/massAssignments.js